
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Toast from 'vux/src/components/toast/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'

export default {
name: "",
props: [""],
data() {
return {
coord: '',
showMap: false,
deviceId: null,
apiurl: "",
loading: false,
imei: "",
deviceName: "",
address: "",
mobile1: "",
mobile2: "",
mobile3: "",
mobile4: "",
mobile5: "",
mobile6: "",
backUrl: '',
latng: ''
};
},

directives: {
TransferDom
},
components: { Loading, Toast, Checker, CheckerItem },
created() {
let _this = this
window.addEventListener('message', function(event) {

var loc = event.data;
if (loc && loc.module === 'locationPicker') {//防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
_this.mapConfirm(loc.latlng.lat, loc.latlng.lng);
}
}, false);
},

beforeMount() {},

mounted() {
this.backUrl = window.location.href
this.latng = this.getUrlCode("latng");
this.$http.get("../static/api/api.json").then(response => {
this.apiurl = response.api;
if (this.$route.query.deviceId) {
this.deviceId = this.$route.query.deviceId;
}else {
this.deviceId = this.getUrlCode('deviceId');
}
this.getDevice(this.deviceId);
});
},
methods: {
getLocation(){
let _this = this
wx.getLocation({
type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
success: function (res) {
console.log(' wx.getLocation===',res)
var latitude = res.latitude; 
var longitude = res.longitude; 
_this.coord = latitude + ',' + longitude;
var speed = res.speed; 
var accuracy = res.accuracy; 
}
});
},
cancelMap(){
this.latng = ''
this.showMap = false
},
mapConfirm(lat,lng){
this.latng = lat + ',' + lng;
this.showMap = false
},
openMap(){
this.getLocation()
this.showMap = true
},
getUrlCode(name) {
return (
decodeURIComponent(
(new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
location.href
) || [, ""])[1].replace(/\+/g, "%20")
) || null
);
},
getDevice(id){
this.$http
.get(this.apiurl + "/web/device/detail/" + id)
.then(res => {
if (res.code === 0) {
this.imei = res.data.sn
this.deviceName = res.data.deviceName
this.address = res.data.address
this.mobile1 = res.data.mobile1
this.mobile2 = res.data.mobile2
this.mobile3 = res.data.mobile3
this.mobile4 = res.data.mobile4
this.mobile5 = res.data.mobile5
this.mobile6 = res.data.mobile6
if (res.data.lat && res.data.lng) {
this.latng = res.data.lat + ',' + res.data.lng;
}
}
})
},
onSubmit(values) {
this.sumbits()
},
sumbits() {
let _this = this;
if (this.deviceName === "") {
this.$vux.toast.text("请输入设备名称", "top");
return;
}
if (this.address === "") {
this.$vux.toast.text("请输入绑定地址", "top");
return;
}
if (this.mobile1 === "") {
this.$vux.toast.text("请输入主要报警手机号", "top");
return;
}
if ("" !== this.mobile2 || null !== this.mobile2) {
if (this.mobile2 === this.mobile1) {
this.$vux.toast.text("备用手机号不能和主要手机号一样", "top");
return;
}
}
if ("" !== this.mobile3 || null !== this.mobile3) {
if (this.mobile3 === this.mobile1) {
this.$vux.toast.text("备用手机号不能和主要手机号一样", "top");
return;
}
}
if ('' !== _this.mobile4|| null !== _this.mobile4) {
if (_this.mobile4 === this.mobile1) {
_this.$vux.toast.text("备用手机号不能和主要手机号一样", "top");
return;
}
}
if ('' !== _this.mobile5|| null !== _this.mobile5) {
if (_this.mobile5 === this.mobile1) {
_this.$vux.toast.text("备用手机号不能和主要手机号一样", "top");
return;
}
}
if ('' !== _this.mobile6|| null !== _this.mobile6) {
if (_this.mobile6 === this.mobile1) {
_this.$vux.toast.text("备用手机号不能和主要手机号一样", "top");
return;
}
}
this.loading = true;
const postData = {
imei: this.imei,
deviceName: this.deviceName,
address: this.address,
mobile1: this.mobile1,
mobile2: this.mobile2,
mobile3: this.mobile3,
mobile4: this.mobile4,
mobile5: this.mobile5,
mobile6: this.mobile6,
latng: this.latng
};
this.$http
.post(this.apiurl + "/web/device/update/" + this.deviceId, postData)
.then(res => {
if (res.code === 0) {
this.$vux.toast.text("修改成功", "top");
this.imei = '';
this.deviceName = '';
this.address = '';
this.mobile1 = '';
this.mobile2 = '';
this.mobile3 = '';
this.mobile4 = '';
this.mobile5 = '';
this.mobile6 = '';
this.latng = ''
this.$router.push({
name: "home",
});
} else {
this.$vux.toast.text(res.message, "top");
}
this.loading = false;
});
}
},

watch: {}
};



// WEBPACK FOOTER //
// ./src/components/deviceEdit.vue